import { type FC } from "react";

import { t } from "i18n/i18n";
import { SquareButton } from "mds/components/buttons/SquareButton";
import { courseGroupingSelectors, courseSelectors } from "store/selectors";
import { useObjectSelector } from "store/store-hooks";

type MoveCoursesConfirmationListItemProps = {
  courseId: string;
};

const MoveCoursesConfirmationListItem: FC<MoveCoursesConfirmationListItemProps> = ({
  courseId,
}) => {
  const course = useObjectSelector(
    (s) => courseSelectors.selectById(s, courseId),
    ["code", "grouping_id"],
  );
  const grouping = useObjectSelector(
    (s) => courseGroupingSelectors.selectById(s, course?.grouping_id),
    ["title"],
  );

  if (!course) {
    return null;
  }

  return (
    <div className="pl-4">
      {course.code} {" - "}
      {grouping?.title}
    </div>
  );
};

type MoveCoursesConfirmationModalProps = {
  courseIds: string[];
  onConfirm: () => void;
  onCancel: () => void;
};

export const MoveCoursesConfirmationModal: FC<MoveCoursesConfirmationModalProps> = ({
  courseIds,
  onConfirm,
  onCancel,
}) => {
  return (
    <div className="flex flex-col">
      <div className="flex flex-col gap-4">
        <div>{t("home.courses.move_courses_confirmation_label")}</div>

        <div className="flex flex-col gap-2 border-l-2 border-score-1">
          {courseIds.map((courseId) => (
            <MoveCoursesConfirmationListItem courseId={courseId} key={courseId} />
          ))}
        </div>

        <div>{t("home.courses.move_courses_confirmation_question")}</div>
      </div>

      <div className="mt-8 flex w-full justify-end gap-2">
        <SquareButton kind="tertiary" size="m" title={t("common.cancel")} onClick={onCancel}>
          {t("common.cancel")}
        </SquareButton>

        <SquareButton
          kind="caution"
          size="m"
          title={t("home.courses.move_courses_title")}
          onClick={onConfirm}
        >
          {t("home.courses.move_courses_title")}
        </SquareButton>
      </div>
    </div>
  );
};
